// @flow

import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { colors } from '../../../styles/GlobalStyle';

type ActionLinkProps = {|
  className?: string,
  children: Node,
  onClick?: () => void,
|};

const RawActionLink = ({ className, children, onClick }: ActionLinkProps) => {
  return (
    <button className={className} type="button" onClick={onClick}>
      {children}
    </button>
  );
};

export const ActionLink: StyledComponent<
  ActionLinkProps,
  {},
  typeof RawActionLink
> = styled(RawActionLink)`
  background: none;
  border: none;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  text-decoration: underline;
  padding: 0;
  cursor: pointer;
  outline: 0;
  transition: all 600ms;

  &:focus {
    color: ${colors.lightYellow};
  }
`;
